import { Button } from '@design-system/button';
import { Container } from '@design-system/container';
import classnames from 'classnames';
import React, { FC } from 'react';

import FilterGroupOptions from './FilterGroupOptions';
import FilterGroupReset from './FilterGroupReset';
import { ItemListingDefaultFilterProps } from './models';
import { getActiveFiltersGroup } from './utils';

const ItemListingDefaultFilter: FC<ItemListingDefaultFilterProps> = ({
  filters,
  clearSelectedFilters,
  getActiveCountForGroup,
  handleFilterChange,
  handleGroupReset,
  filter,
  activeGroup,
  handleActiveGroup,
  isMobile,
}) => (
  <Container maxWidth="full-width" className="filter-wrapper">
    {filters.map(({ label, options }) => {
      const isGroupActive = activeGroup === label;

      return (
        <div className="filter-group" key={label}>
          <Button
            className={classnames('filter-group__button', {
              'filter-group__button--active': isGroupActive,
            })}
            iconSuffix={{
              props: {
                icon: 'arrowDown',
              },
            }}
            variant="secondary"
            size="large"
            onClick={() => handleActiveGroup(label)}
          >
            {label}
            {getActiveCountForGroup(label) ? (
              <span className="filter-group__active-count">
                {getActiveCountForGroup(label)}
              </span>
            ) : null}
          </Button>
          {isGroupActive && isMobile ? (
            <FilterGroupOptions
              {...{ options, filter, handleFilterChange }}
              activeGroup={label}
            />
          ) : null}
          {getActiveCountForGroup(label) && isGroupActive && isMobile ? (
            <FilterGroupReset
              {...{ handleGroupReset, clearSelectedFilters }}
              activeGroup={label}
            />
          ) : null}
        </div>
      );
    })}
    {!isMobile ? (
      <>
        {activeGroup ? <div className="filter-group__divider" /> : null}
        {getActiveFiltersGroup(filters, activeGroup) ? (
          <FilterGroupOptions
            {...{ filter, handleFilterChange, activeGroup }}
            options={getActiveFiltersGroup(filters, activeGroup)!.options}
          />
        ) : null}
      </>
    ) : null}
    {getActiveCountForGroup(activeGroup) && !isMobile ? (
      <FilterGroupReset
        {...{ handleGroupReset, activeGroup, clearSelectedFilters }}
      />
    ) : null}
  </Container>
);

export default ItemListingDefaultFilter;
